import { useState } from 'react';
import { useToast } from '../components/Toast.tsx';
import { LandingBackdrop } from './landing/LandingBackdrop.tsx';
import { LandingContactModal } from './landing/LandingContactModal.tsx';
import { LandingHero } from './landing/LandingHero.tsx';
import { LandingNav } from './landing/LandingNav.tsx';
import { LandingSections } from './landing/LandingSections.tsx';
import { CONTACT_EMAIL } from './landing/landingData.ts';
import { useLandingEvents } from './landing/useLandingEvents.ts';
import './Welcome.css';

export function Welcome() {
  const toast = useToast();
  const { rows, eventCount } = useLandingEvents();
  const [contactOpen, setContactOpen] = useState(false);
  const [contactSubject, setContactSubject] = useState('CDVI Edge demo');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  function openContact(subject: string) {
    setContactSubject(subject);
    setContactOpen(true);
  }

  function handleSubmitted() {
    toast.success('Opening your mail client', 'Your walkthrough request draft is ready to send.');
    setContactOpen(false);
    setName('');
    setEmail('');
    setMessage('');
  }

  return (
    <div className="landing">
      <LandingBackdrop />

      <div className="landing-inner">
        <span className="landing-coord tl">CDVI/EDGE/v2 / relay mesh</span>
        <span className="landing-coord tr">ATRIUM command cloud / live</span>
        <LandingNav onContact={() => openContact('CDVI Edge demo')} />
        <LandingHero rows={rows} eventCount={eventCount} onContact={openContact} />
        <LandingSections onContact={openContact} />

        <footer className="landing-footer">
          <span>© {new Date().getFullYear()} CDVI EDGE</span>
          <span className="footer-sep">/</span>
          <span>Cloud control plane for CDVI ATRIUM</span>
          <div className="spacer" />
          <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
          <span className="footer-sep">/</span>
          <a href="/handler/sign-in">sign in</a>
        </footer>
      </div>

      <LandingContactModal
        open={contactOpen}
        subject={contactSubject}
        name={name}
        email={email}
        message={message}
        setName={setName}
        setEmail={setEmail}
        setMessage={setMessage}
        onClose={() => setContactOpen(false)}
        onSubmitted={handleSubmitted}
      />
    </div>
  );
}
